module.exports = __webpack_public_path__ + "static/media/CTLI_13-235w.5a7745bc.jpg";